export default {
    nav_drawer: {
      product_index: 0,
      sub_product_index: 0,
      expand_on_hover: true,
      mini_variant: true,
      right:true
    },
    bottom_sheet: {
      option_index: 0,
      is_open: false,
    },
    bootstrap_alert: {
      alert_text: '',
      dismissSecs: 5,
      dismissCountDown: 0,
      variant: 'success'
    }
  }